import { useContext } from 'react';
import { CustomTableData } from "common";
import { Button, CircularProgress } from '@mui/material'
import { Edit3, Info, Trash2 } from 'react-feather'
import { TooltipInformation } from 'common';
import TooltipAprobacion from 'common/TooltipAprobacion/TooltipAprobacion'

export const VehiclesAppliesTable = ({ useFetchInit }) => {

  const {
    FetchData,
    Actions,
    globalStates
  } = useFetchInit


  const { fetchAllVehicleApplication: { vehicleApplications } } = FetchData

  const { handleClickFetchInfoApplication, handleClickDeleteVehicleApplication, pending } = Actions

  // const {data, deleteRecord, getDocumentRegistry} = useContext(VehicleAppliesContext);

  const columnConfig = [
    {
      headerName: 'info',
      maxWidth: 80,
      cellStyle: () => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }),
      cellRenderer: (params) => {

        const {
          idcredito,
          usuario_creo,
          fecha_creo,
          usuario_modifico,
          fecha_modifico,
        } = params.data;

        return <TooltipInformation
          idregistro={idcredito}
          usuario_creo={usuario_creo}
          fecha_creo={fecha_creo}
          usuario_modifico={usuario_modifico}
          fecha_modifico={fecha_modifico}
        />
      },
    },
    { field: "contrato_codigo", headerName: "IDENTIFICADOR", minWidth: 140 },
    { field: "credito_fecha", headerName: "FECHA", minWidth: 140, filter: true },
    { field: "datos_cliente", headerName: "DATOS DEL CLIENTE", minWidth: 270, filter: true },
    { field: "descripcion_vehicle", headerName: "VEHICULO", minWidth: 200, filter: true },
    { field: "plazo", headerName: "PLAZO", minWidth: 80, filter: true },
    { field: "origen_financiero", headerName: "ORIGEN FINANCIERO", minWidth: 180, filter: true, valueFormatter: (params) => params.value ?? '—', },
    { field: "enganche", headerName: "ENGANCHE", minWidth: 140, filter: true },
    { field: "saldo_financiar", headerName: "FINANCIAMIENTO", minWidth: 170, filter: true },
    {
      headerName: "Aprobacion",
      field: "aprobacion_check",
      minWidth: 250,
      maxWidth: 250,
      filter: true,
      cellStyle: () => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }),
      cellClass: (params) => {
        if (params.value === 'Pendiente Aprobacion') return 'bg-warning';
        if (params.value === 'Pendiente Aprobacion Contrato') return 'bg-warning';
        if (params.value === 'Pendiente Contrato') return 'bg-warning';
        if (params.value === 'Borrador') return 'bg-warning';
        if (params.value === 'Rechazado') return 'bg-danger';
        if (params.value === 'Devuelto a Gestor') return 'bg-danger';
        if (params.value === 'Devuelto a Juridico') return 'bg-danger';
      },
      cellRenderer: (params) => {
        const { idcredito, aprobacion_usuario, aprobacion_fecha } = params.data

        if (params.value === 'Pendiente Aprobacion') return (
          <TooltipAprobacion
            tag_id='tooltip_arr_solicitudes_aprobacion_'
            class_icon='fa-solid fa-user-clock'
            text_span='Pendiente Aprobacion'
            idcontrato={idcredito}
            aprobacion_usuario={aprobacion_usuario}
            aprobacion_fecha={aprobacion_fecha}
          />
        );

        if (params.value === 'Pendiente Aprobacion Contrato') return (
          <TooltipAprobacion
            tag_id='tooltip_arr_solicitudes_aprobacion_'
            class_icon='fa-solid fa-user-clock'
            text_span='Pendiente Aprobacion Contrato'
            idcontrato={idcredito}
            aprobacion_usuario={aprobacion_usuario}
            aprobacion_fecha={aprobacion_fecha}
          />
        );

        if (params.value === 'Pendiente Contrato') return (
          <TooltipAprobacion
            tag_id='tooltip_arr_solicitudes_aprobacion_'
            class_icon='fa-solid fa-user-lock'
            text_span='Pendiente Contrato'
            idcontrato={idcredito}
            aprobacion_usuario={aprobacion_usuario}
            aprobacion_fecha={aprobacion_fecha}
          />
        );

        if (params.value === 'Borrador') return (
          <TooltipAprobacion
            tag_id='tooltip_arr_solicitudes_aprobacion_'
            class_icon='fa-solid fa-user-lock'
            text_span='Borrador'
            idcontrato={idcredito}
            aprobacion_usuario={aprobacion_usuario}
            aprobacion_fecha={aprobacion_fecha}
          />
        );

        if (params.value === 'Rechazado') return (
          <TooltipAprobacion
            tag_id='tooltip_arr_solicitudes_aprobacion_'
            class_icon='fa-solid fa-circle-xmark'
            text_span='Rechazado'
            idcontrato={idcredito}
            aprobacion_usuario={aprobacion_usuario}
            aprobacion_fecha={aprobacion_fecha}
          />
        );
        if (params.value === 'Devuelto a Gestor') return (
          <TooltipAprobacion
            tag_id='tooltip_arr_solicitudes_aprobacion_'
            class_icon='fa-solid fa-user-times'
            text_span='Devuelto a Gestor'
            idcontrato={idcredito}
            aprobacion_usuario={aprobacion_usuario}
            aprobacion_fecha={aprobacion_fecha}
          />
        );
        if (params.value === 'Devuelto a Juridico') return (
          <TooltipAprobacion
            tag_id='tooltip_arr_solicitudes_aprobacion_'
            class_icon='fa-solid fa-user-times'
            text_span='Devuelto a Juridico'
            idcontrato={idcredito}
            aprobacion_usuario={aprobacion_usuario}
            aprobacion_fecha={aprobacion_fecha}
          />
        );
      }
    },
    {
      headerName: "OPCIONES",
      minWidth: 440,
      cellRenderer: (params) => {

        const { idcredito, idcotizacion, idvehiculo, aprobacion_check, contractLoaded } = params.data
        if ((aprobacion_check === 'Pendiente Aprobacion') || (aprobacion_check === 'Devuelto a Juridico') || (aprobacion_check === 'Rechazado') || (aprobacion_check === 'Pendiente Aprobacion Contrato') || (aprobacion_check === 'Pendiente Contrato')) return (
          <>
            <Button
              startIcon={<Info />}
              variant='contained'
              size='small'
              color='info'
              sx={{ marginRight: '8px' }}
              onClick={() => handleClickFetchInfoApplication(idcredito, idcotizacion, idvehiculo, 'READONLY', contractLoaded)}
              style={{ width: 150 }}
            >
              Solicitud
            </Button>
          </>
        )

        if ((aprobacion_check === 'Devuelto a Gestor')) return (
          <>
            <Button
              startIcon={<Edit3 />}
              variant='contained'
              size='small'
              color='success'
              sx={{ marginRight: '8px' }}
              onClick={() => handleClickFetchInfoApplication(idcredito, idcotizacion, idvehiculo, 'EDITABLE', contractLoaded)}
              style={{ width: 150 }}
            >
              Editar
            </Button>
          </>
        )

        // Si el contrato está pendiente de aprobación se debe permitir modificar
        if (aprobacion_check === 'Borrador') return (
          <>
            <Button
              startIcon={<Edit3 />}
              variant='contained'
              size='small'
              color='success'
              sx={{ marginRight: '8px' }}
              onClick={() => handleClickFetchInfoApplication(idcredito, idcotizacion, idvehiculo, 'EDITABLE', contractLoaded)}
              style={{ width: 150 }}
            >
              Editar
            </Button>
            {!params.data.idgestion_refinanciamiento && (
            <Button
              startIcon={pending.deleteApplication ? <CircularProgress size={16} color="inherit" /> : <Trash2 />}
              variant='contained'
              size='small'
              color='error'
              onClick={() => handleClickDeleteVehicleApplication(idcredito)}
              style={{ width: 150 }}
              disabled={pending.deleteApplication}
            >
              Eliminar
            </Button>
            )}
          </>

        )
      },
    },
  ];
  return (
    <>
      <CustomTableData
        rowConfig={vehicleApplications}
        columnConfig={columnConfig} />
    </>
  );
};
